import { isEmpty } from 'lodash';
export const buildESQueryString = value => {
  value = value.trim();
  let search = '';
  const organizationNameESQuery = 'names.languages.EN.full:';
  const locationESQuery =
    'contactsInformation.liss.locality.representation.formatted_address:';
  const phoneESQuery =
    'contactsInformation.contacts.channels.descriptor.number:';
  if (!isEmpty(value)) {
    const searchValue = buildSearchValue(value);
    search = `${organizationNameESQuery}${searchValue} OR ${locationESQuery}${searchValue} OR ${phoneESQuery}${searchValue}`;
  } else {
    const wildcardChar = '*';
    search = `${organizationNameESQuery}${wildcardChar} OR ${locationESQuery}${wildcardChar} OR ${phoneESQuery}${wildcardChar}`;
  }
  return search;
};

export const buildSearchValue = value => {
  const searchInput = value.replace(/\W+/gm, ' ');
  const searchWords = searchInput.split(' ');
  let searchValue;
  searchWords.forEach((searchWord, index) => {
    if (index > 0) {
      searchValue += ` OR *${searchWord}*`;
    } else {
      searchValue = `*${searchWord}*`;
    }
  });
  return `(${searchValue})`;
};
